import { type TFunction } from 'react-i18next';
import type { HistoryStatus, Step, KizenNodeType } from './types';
import { AUTOMATION_STEPS } from './steps';

const errorStatus: HistoryStatus[] = ['failed', 'paused_by_failure'];

export const errorByStatus = (status: HistoryStatus) =>
  errorStatus.includes(status);

const pendingStatus: HistoryStatus[] = ['pending', 'pending_throttled'];

export const pendingByStatus = (status: HistoryStatus) =>
  pendingStatus.includes(status);

const debugStatus: HistoryStatus[] = [
  'debug_waiting',
  'paused_after_execution',
  'waiting_for_branches',
];

export const debugByStatus = (status: HistoryStatus) =>
  debugStatus.includes(status);

export const pasteStepTypeNameLookup = (
  stepType: KizenNodeType,
  t: TFunction
) => {
  return AUTOMATION_STEPS[stepType]?.label?.(t);
};

export const omitObjectKeys = <T extends object, K extends keyof T>(
  obj: T,
  keys: K[]
): Omit<T, K> => {
  const omitted = { ...obj };
  for (const key of keys) {
    delete omitted[key];
  }
  return omitted;
};

export const getObjectKeys = <T extends string | number | symbol>(
  obj?: Record<T, any> | Partial<Record<T, any>> | null | undefined
): T[] => {
  if (!obj || typeof obj !== 'object') {
    return [];
  }

  return Object.keys(obj) as T[];
};

export const getGrandChildrenCount = (steps: Array<Step>, stepId: string) => {
  const children = new Set(
    steps.filter(({ parentKey }) => parentKey === stepId).map(({ id }) => id)
  );
  return steps.filter(({ parentKey }) => parentKey && children.has(parentKey))
    .length;
};
